import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';
import React, { Component, RefObject } from 'react';

import './index.css';

const b = cn('copy-button');
const enum COPYING_STATUS {
    IDLE = 'idle',
    SUCCESS = 'success'
}

interface Props {
    textRef: RefObject<HTMLElement>;
    mixClassName?: string;
}

interface State {
    copyingStatus: COPYING_STATUS;
}

class CopyButton extends Component<Props, State> {
    static contextType = LangContext;
    hasClipboardAPI: boolean;

    state = {
        copyingStatus: COPYING_STATUS.IDLE
    };

    constructor(props: Props) {
        super(props);

        this.hasClipboardAPI = typeof window !== 'undefined' && ('clipboard' in window.navigator);

        this.setCopyingStatus = this.setCopyingStatus.bind(this);
        this.copy = this.copy.bind(this);
    }

    setCopyingStatus(copyingStatus: COPYING_STATUS) {
        this.setState({
            copyingStatus
        });
    }

    copy(text: string) {
        navigator.clipboard
            .writeText(text)
            .then(() => this.setCopyingStatus(COPYING_STATUS.SUCCESS))
            .finally(() => {
                setTimeout(
                    () => this.setCopyingStatus(COPYING_STATUS.IDLE),
                    1500
                );
            });
    }

    render() {
        const text = this.props.textRef?.current?.textContent;

        if (!this.hasClipboardAPI || !text) {
            return null;
        }

        const { mixClassName } = this.props;
        const { copyingStatus } = this.state;
        const isSuccess = copyingStatus === COPYING_STATUS.SUCCESS;
        const { dictionary } = this.context;

        return (
            <div className={b({}, [mixClassName])}>
                <button
                    className={b('button')}
                    title={dictionary.copy_to_clipboard}
                    /* eslint-disable-next-line react/jsx-no-bind */
                    onClick={() => this.copy(text)}
                    />

                <div className={b('success-tooltip', { shown: isSuccess })}>
                    <span>{dictionary.copied}</span>
                </div>
            </div>
        );
    }
}

export default CopyButton;
